var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('mpx-view',{staticClass:"ts-button",class:([_vm.activeClass,_vm.className,_vm.externClass]),style:(_vm._f("transRpxStyle")([(_vm.borderStyle)])),on:{"tap":[_vm.handleClick,function($event){$event.stopPropagation();return _vm.handleCatchClick.apply(null, arguments)}]}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }